export const CIVILBUDGETDETAIL_LOADING = "CIVILBUDGETDETAIL_LOADING";
export const CIVILBUDGETDETAIL_RESET = "CIVILBUDGETDETAIL_RESET";
export const GET_CIVILBUDGETDETAIL = "GET_CIVILBUDGETDETAIL";
export const GET_CIVILBUDGETDETAIL_SUCCESS = "GET_CIVILBUDGETDETAIL_SUCCESS";
export const GET_CIVILBUDGETDETAIL_FAIL = "GET_CIVILBUDGETDETAIL_FAIL";
export const DELETE_CIVILBUDGETDETAIL = "DELETE_CIVILBUDGETDETAIL"
export const DELETE_CIVILBUDGETDETAIL_SUCCESS = "DELETE_CIVILBUDGETDETAIL_SUCCESS"
export const DELETE_CIVILBUDGETDETAIL_FAIL = "DELETE_CIVILBUDGETDETAIL_FAIL"
export const UPDATE_CIVILBUDGETDETAIL = "UPDATE_CIVILBUDGETDETAIL"
export const UPDATE_CIVILBUDGETDETAIL_SUCCESS = "UPDATE_CIVILBUDGETDETAIL_SUCCESS"
export const UPDATE_CIVILBUDGETDETAIL_FAIL = "UPDATE_CIVILBUDGETDETAIL_FAIL"
export const ADD_NEW_CIVILBUDGETDETAIL = "ADD_NEW_CIVILBUDGETDETAIL"
export const ADD_CIVILBUDGETDETAIL_SUCCESS = "ADD_CIVILBUDGETDETAIL_SUCCESS"
export const ADD_CIVILBUDGETDETAIL_FAIL = "ADD_CIVILBUDGETDETAIL_FAIL"